export enum QuestionType {
  MULTI_CHOICE = "multiple-choice",
  MULTI_SELECT = "multi-select",
  OPEN_TEXT = "open-text",
  SINGLE_SELECT = "single-select"
}
